'use strict'

export default class MrFilters {
  constructor () {
    this.filterGrid = document.querySelectorAll('.mr-filters-grid[id]')
    this.selectedFilters = []

    this._clearData()
  }

  start () {
    this.filterGrid.forEach((grid) => {
      this._initializeView(grid.id)
      const filtersGroup = document.querySelectorAll('.mr-filters[data-grid="' + grid.id + '"]')

      filtersGroup.forEach((group) => {
        const activeFilter = document.querySelector('.mr-filters[data-filter-group="' + group.dataset.filterGroup + '"] .active')
        const filterAll = document.querySelector('.mr-filters[data-filter-group="' + group.dataset.filterGroup + '"] .all')
        const savedFilters = this._getActiveFilters(grid.id)

        if (filterAll && (!activeFilter || activeFilter.length === 0)) {
          filterAll.classList.add('active')
        }

        if (!savedFilters) {
          const filters = group.querySelectorAll('.mr-filters[data-filter-group="' + group.dataset.filterGroup + '"] .mr-filter')
          filters[0].classList.add('active')
        }

        if (group.tagName === 'SELECT') {
          this._setFilterEventListener(group.dataset.filterGroup, group, grid.id)
        } else {
          const filters = group.querySelectorAll('.mr-filter')

          filters.forEach((filter) => {
            this._setFilterEventListener(group.dataset.filterGroup, filter, grid.id)
          })
        }
      })

      this._filter(grid.id)
    })
  }

  _filter (gridId) {
    const grids = document.querySelectorAll('#' + gridId + ',[data-related-grid="' + gridId + '"]')

    grids.forEach((grid) => {
      const gridItems = grid.querySelectorAll('.mr-filters-item')
      const filtersGroup = document.querySelectorAll('.mr-filters[data-grid="' + gridId + '"]')
      const _self = this
      this.selectedFilters = []

      filtersGroup.forEach((group) => {
        if (group.tagName === 'SELECT') {
          const filter = group.options[group.selectedIndex].dataset.filter

          if (filter !== '*') {
            _self.selectedFilters.push(filter)
          }
        } else {
          const filterElement = group.querySelector('.mr-filter.active')

          if (filterElement && filterElement.dataset.filter !== '*') {
            _self.selectedFilters.push(filterElement.dataset.filter)
          }
        }
      })

      if (this.selectedFilters.length > 0) {
        let selector = ''

        this.selectedFilters.forEach((filter) => {
          selector += ('.' + filter)
        })

        gridItems.forEach((item) => {
          item.classList.add('hidden')
        })

        grid.querySelectorAll(selector).forEach((item) => {
          item.classList.remove('hidden')
        })

        this._updateLocalStorage('mr-filters-' + gridId, this.selectedFilters)
      } else {
        gridItems.forEach((item) => {
          item.classList.remove('hidden')
        })

        this._updateLocalStorage('mr-filters-' + gridId, [])
      }
    })
  }

  _getActiveFilters (gridId) {
    return JSON.parse(localStorage.getItem('mr-filters-' + gridId))
  }

  _initializeView (gridId) {
    const grid = document.getElementById(gridId)
    const gridItems = grid.querySelectorAll('.mr-filters-item')
    const activeFilters = this._getActiveFilters(gridId)
    let selector = ''

    if (grid && gridItems) {
      if (activeFilters && activeFilters.length > 0) {
        activeFilters.forEach((filter) => {
          selector += ('.' + filter)

          const filterElement = document.querySelector('.mr-filter[data-filter="' + filter + '"]')

          if (filterElement) {
            if (filterElement.tagName === 'OPTION') {
              filterElement.setAttribute('selected', 'true')
            } else {
              filterElement.classList.add('active')
            }
          }
        })
      }

      if (selector !== '') {
        gridItems.forEach((item) => {
          item.classList.add('hidden')
        })

        grid.querySelectorAll(selector).forEach((item) => {
          item.classList.remove('hidden')
        })
      }
    }
  }

  _issetLocalStorage (name) {
    return localStorage.getItem(name) !== null
  }

  _isTarget (classes, activeFilters) {
    let isTarget = false

    activeFilters.forEach((filter) => {
      if (classes.contains(filter)) {
        isTarget = true
      }
    })

    return isTarget
  }

  _resetFilter (gridId) {
    localStorage.removeItem('mr-filters-' + gridId)

    if (gridId.split(' ').length > 1) {
      gridId.split(' ').forEach((grid) => {
        this._filter(grid)
      })
    } else {
      this._filter(gridId)
    }
  }

  _setFilterEventListener (group, filter, gridId) {
    if (filter.tagName === 'SELECT') {
      filter.addEventListener('change', () => {
        this._filter(gridId)
      })
    } else {
      filter.addEventListener('click', (event) => {
        const target = event.target.dataset.filter ? event.target : event.target.parentNode

        if (target.classList.contains('active')) {
          const allFilter = document.querySelector('.mr-filters[data-filter-group="' + group + '"] .all')

          if (allFilter) {
            allFilter.classList.add('active')
          }

          if (gridId.split(' ').length > 1) {
            gridId.split(' ').forEach((grid) => {
              this._filter(grid)
            })
          } else {
            this._filter(gridId)
          }
        } else {
          const activeFilter = document.querySelector('.mr-filters[data-filter-group="' + group + '"] .active')

          if (activeFilter) {
            activeFilter.classList.remove('active')
          }

          target.classList.toggle('active')

          if (gridId.split(' ').length > 1) {
            gridId.split(' ').forEach((grid) => {
              this._filter(grid)
            })
          } else {
            this._filter(gridId)
          }
        }
      })
    }
  }

  _updateLocalStorage (localStorageKey, data) {
    localStorage.setItem(localStorageKey, JSON.stringify(data))
  }

  _clearData () {
    const resetButton = document.querySelector('.mr-filters-container button')

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        document.querySelectorAll('li.mr-filter').forEach(item => item.classList.remove('active'))
        document.getElementById('persons-grid').querySelectorAll('.mr-filters-item').forEach(item => item.classList.remove('hidden'))
        localStorage.removeItem('mr-filters-persons-grid')
      })
    }
  }
}
